import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { SubmissionError } from 'redux-form';

import SearchPurchasesForm from 'components/SearchPurchasesForm/SearchPurchasesForm';
import PurchaseList from 'components/PurchaseList/PurchaseList';
import TransferLineItemForm from 'components/TransferLineItemForm/TransferLineItemForm';
import { combinePurchaseWithSubs } from '../../helpers/purchases';
import Spinner from 'components/Spinner';

const isDiffLineItems = (lineItems1, lineItems2) => {
  if ((!lineItems1 && lineItems2) || (lineItems1 && !lineItems2)) {
    return true;
  }

  if (
    (!lineItems1.length && lineItems2.length) ||
    (lineItems1.length && !lineItems2.length)
  ) {
    return true;
  }

  for (let i = 0; i < lineItems2.length; i++) {
    const item2 = lineItems2[i];
    const item1 = lineItems1[i];
    if (!item1 || item2.id !== item1.id) {
      return true;
    }
  }

  return false;
};

class LineItemTransfer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: undefined,
      wasLoaded: false,
      loading: false,
    };
  }

  handleSearch = (values) => {
    const { searchPurchases, purchase } = this.props;
    this.setState({ loading: true });
    return searchPurchases({ ...values, status: purchase.status })
      .then(() => {
        this.setState({ wasLoaded: true });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  filterOutInitialPurchase = (purchases) => {
    const { purchase } = this.props;
    if (!purchases) {
      return [];
    }

    return purchases.filter((p) => p.id !== purchase.id);
  };

  componentDidMount() {
    const { findPurchase, purchaseId, purchase, lineItemsPage } = this.props;
    if (!purchase) {
      findPurchase(purchaseId).catch((e) => console.log(e));
    }

    if (lineItemsPage && lineItemsPage.toString() !== '1') {
      this.loadLineItems();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { lineItemsPage, lineItems } = this.props;
    if (prevProps.lineItemsPage !== lineItemsPage) {
      this.loadLineItems();
    }

    if (
      prevProps.lineItems !== lineItems &&
      isDiffLineItems(prevProps.lineItems, lineItems)
    ) {
      const lineItemForm = document.getElementById('transfer-line-item-form');
      if (lineItemForm) {
        window.scrollTo({
          top: lineItemForm.offsetTop,
          behavior: 'smooth',
        });
      }
    }
  }

  loadLineItems = () => {
    const { fetchPurchaseLineItems, lineItemsPage, purchaseId } = this.props;
    this.setState({ loading: true });
    fetchPurchaseLineItems(purchaseId, lineItemsPage)
      .catch((e) => console.log(e))
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  selectPurchase(purchase) {
    if (purchase) {
      this.setState({
        selected: purchase,
      });
    }
  }

  render() {
    const {
      purchase,
      purchases,
      subs,
      isAdmin,
      transferLineItems,
      submitSucceeded,
      lineItems,
      lineItemsPage,
    } = this.props;
    const { selected, wasLoaded, loading } = this.state;

    const isPending = purchase && purchase.status === 'pending';
    const isOverdue = purchase && purchase.status === 'overdue';
    const isOpen = purchase && purchase.status === 'open';

    const filteredPurchases = this.filterOutInitialPurchase(purchases);

    if (!purchase) {
      return 'Loading';
    }

    if (purchase && !isAdmin) {
      return <Redirect to={`/purchases/${purchase.id}/view`} />;
    }

    if (purchase && submitSucceeded) {
      return <Redirect to={`/purchases/${selected.id}/view`} />;
    }

    if (purchase && !isPending && !isOverdue && !isOpen) {
      return <Redirect to={`/purchases/${purchase.id}/view`} />;
    }

    return (
      <div>
        <h1>Transfer Line Items</h1>
        <SearchPurchasesForm
          onSubmit={this.handleSearch}
          fields={['user_profile', 'id']}
        />

        {filteredPurchases && filteredPurchases.length > 0 && (
          <div className="mar-t">
            <PurchaseList
              purchases={filteredPurchases}
              actionComponent={(purch) => (
                <button
                  className={
                    selected && selected.id === purch.id
                      ? 'btn btn-primary w100'
                      : 'btn btn-default w100'
                  }
                  onClick={() => this.selectPurchase(purch)}
                >
                  {selected && selected.id === purch.id ? 'Selected' : 'Select'}
                </button>
              )}
            />
          </div>
        )}

        {wasLoaded && filteredPurchases && filteredPurchases.length === 0 && (
          <div className="mar-t">No results</div>
        )}

        <div id="transfer-line-item-form"></div>
        {selected && selected.id ? (
          <TransferLineItemForm
            purchase={purchase}
            from={combinePurchaseWithSubs(purchase, lineItems, subs)}
            to={selected}
            lineItemsPage={lineItemsPage}
            loading={this.state.loading}
            onSubmit={(values) => {
              const selectedLines = Object.entries(values).reduce(
                (acc, [key, value]) => {
                  if (value) {
                    acc[key] = value;
                  }
                  return acc;
                },
                {},
              );
              const lines = Object.keys(selectedLines).map((value) => {
                const id = value.split('_')[1];
                return parseInt(id, 10);
              });

              if (!lines.length) {
                throw new SubmissionError({
                  _error: 'Select at least 1 lineitem',
                });
              }
              return transferLineItems(
                lines,
                purchase.id,
                selected.id,
                selected.user_profile,
              );
            }}
          />
        ) : null}
        <Spinner showLoader={loading} />
      </div>
    );
  }
}

export default LineItemTransfer;
